import Vue from "vue"
import Edit from "./Edit.js"
import Activity from "./Activity.js"
import Review from "./Review.js"
import Fullscreen from "./Fullscreen.js"
import PresenterMode from './PresenterMode.js';
import AiRelated from './AiRelated.js';
import * as models from "../../models/models.js"
import applicationBlocks from "../../blocks/_components/applicationBlocks.js"
import { getUniqueArray } from "../../utils/utils.js"
import branding, { injectTenantFontFace } from "../../../../branding.js"
import cloneDeep from "lodash.clonedeep"
import { createNavigation } from '../SlidesNavigation/navigationFactory';

export default function (vm) {
  let contents = vm.value.body.contents
  if (!contents || Object.keys(contents).length === 0) {
    vm.value.body.contents = new models.PContentLessonPlan()
  } else {
    vm.value.body.contents = new models.PContentLessonPlan(contents)
  }

  return new Vue({
		mixins: [Edit, Activity, Review, Fullscreen, PresenterMode, AiRelated],
		data() {
			return {
				navigation: null,
				vm: vm,

				mode: vm.mode,

				hideSlidesService: null,

				// edit layouts section
				editLayouts: false,
				imported: false,

				activityState: vm.activityState ? Object.assign({}, vm.activityState) : undefined,

				gridSize: [1, 1],
				prevGridSize: undefined,
				gridSizes: [
					[1, 1],
					[40, 22.5],
					[80, 45],
					[120, 67.5],
					[160, 90],
					[320, 180]
				],

				fontFamilies: [
					{ text: 'Default', value: 'inherit' },
					{ text: 'Roboto', value: 'Roboto' },
					{ text: 'Arial', value: 'Arial' },
					{ text: 'Calibri', value: 'Calibri' },
					{ text: 'Courier', value: 'Courier' },
					{ text: 'Courier New', value: 'Courier New' },
					{ text: 'Didot', value: 'Didot' },
					{ text: 'Garamond', value: 'Garamond' },
					{ text: 'Georgia', value: 'Georgia' },
					{ text: 'Helvetica', value: 'Helvetica' },
					{ text: 'Lato', value: 'Lato' },
					{ text: 'Lucida Console', value: 'Lucida Console' },
					{ text: 'Monaco', value: 'Monaco' },
					{ text: 'Manrope', value: 'Manrope' },
					{ text: 'Optima', value: 'Optima' },
					{ text: 'Perpetua', value: 'Perpetua' },
					{ text: 'Sora', value: 'Sora' },
					{ text: 'Tahoma', value: 'Tahoma' },
					{ text: 'Times New Roman', value: 'Times New Roman' },
					{ text: 'Trebuchet MS', value: 'Trebuchet MS' },
					{ text: 'Verdana', value: 'Verdana' }
				],
				notificationHandler: {
					active: false,
					text: '',
					color: 'error'
				},
				answerHandler: {
					active: false,
					data: {}
				},
				slideNumberShown: false,
				subtitlesActive: false,
				subtitlesText: false,
				defaultSubtitles: false,
				compressedActivityState: false,
				notesFontSize: 14,
				rightPanelWidth: 400,
				rightPanelMargin: 400,
				rightPanelMinWidth: 150,
				rightPanelMaxWidth: 1500,
				rightPanelBarWidth: 80,
				panelHoverArea: 10,
				lastRightPanelSelectedTitle: null
			};
		},
		computed: {
			gridIndex() {
				return this.gridSizes.findIndex(grid => grid[0] === this.gridSize[0]);
			},
			comments() {
				return vm.comments;
			},
			view() {
				return vm.view;
			},
			applicationBlocks() {
				return {
					title: 'Application Blocks',
					application: true,
					galleries: applicationBlocks
				};
			},
			galleryLessonPlan() {
				return {
					title: 'This Lesson Plan Blocks',
					collapsed: true,
					galleries: this.lessonPlanContents.galleries
						? this.lessonPlanContents.galleries.filter(gallery => gallery.imported === false)
						: []
				};
			},
			galleryImportedLessonPlans() {
				return {
					title: 'Imported Lesson Plan Blocks',
					application: true,
					collapsed: true,
					galleries: this.lessonPlanContents.galleries
						? this.lessonPlanContents.galleries.filter(gallery => gallery.imported !== false)
						: []
				};
			},
			galleryGroups() {
				const total = [this.applicationBlocks];
				if (this.galleryLessonPlan.galleries.length > 0) {
					total.push(this.galleryLessonPlan);
				}
				if (this.galleryImportedLessonPlans.galleries.length > 0) {
					total.push(this.galleryImportedLessonPlans);
				}
				return total;
			},
			lessonPlanContents() {
				return vm.value.body.contents;
			},
			globalStyles() {
				return this.lessonPlanContents.settings.styles;
			},
			isSelectedSection() {
				return this.isSection(this.navigation.selectedSlide);
			},
			isSelectedSlideContent() {
				return !this.isSection(this.navigation.selectedSlide);
			},
			selectedSlideObjectives() {
				if (
					!this.navigation.selectedSlide ||
					(this.navigation.selectedSlide.path &&
						this.navigation.selectedSlide.path.length < 2 &&
						!this.isSelectedSection)
				)
					return [];

				if (this.isSelectedSection) return this.navigation.selectedSlide.objectives;

				let parentObjectives = [];
				for (let i = 0; i < this.navigation.selectedSlide.path.length - 1; i++) {
					const parentSlide = this.getSlideFromSlideId(this.navigation.selectedSlide.path[i].id);
					parentObjectives = parentSlide ? parentObjectives.concat(parentSlide.objectives) : parentObjectives;
				}

				return getUniqueArray(parentObjectives, '_id');
			},
			objectives() {
				let objectives = [];
				this.navigation.slideArray.forEach(slide => {
					if (slide.objectives && slide.objectives.length > 0) {
						objectives = objectives.concat(slide.objectives);
					}
				});
				return getUniqueArray(objectives, '_id');
			},
			objectiveCustomIdGlobalVariable() {
				if (!this.selectedSlideObjectives.length) return '';

				return this.selectedSlideObjectives[0].header.metadata.custom_id;
			},
			objectiveTitleGlobalVariable() {
				if (!this.selectedSlideObjectives.length) return '';

				return this.selectedSlideObjectives[0].header.metadata.title;
			},
			objectiveTextGlobalVariable() {
				if (!this.selectedSlideObjectives.length) return '';

				return this.selectedSlideObjectives[0].body.contents.text;
			},
			generalObjective() {
				if (!this.lessonPlanContents.instructionalSettings || !this.lessonPlanContents.instructionalSettings.objective)
					return false;
				return this.lessonPlanContents.instructionalSettings.objective;
			},
			totalTimeLearningObjects() {
				let totalMinutes = 0;
				this.navigation.slideArray.forEach(slide => {
					if (slide.type === 'LearningObject' && slide.completionTime) {
						totalMinutes += slide.completionTime;
					}
				});

				return totalMinutes;
			},
			totalTimeLearningObjectsFormatted() {
				let totalMinutesFormatted = '';
				let hours = 0;
				let minutes = 0;
				if (this.totalTimeLearningObjects >= 60) {
					hours = parseInt(this.totalTimeLearningObjects / 60);
					minutes = this.totalTimeLearningObjects % 60;
				} else {
					minutes = this.totalTimeLearningObjects % 60;
				}

				if (hours !== 0) totalMinutesFormatted += `${hours} hour${hours > 1 ? 's' : ''} `;
				if (minutes !== 0) totalMinutesFormatted += `${minutes} minute${minutes > 1 ? 's' : ''}`;
				return totalMinutesFormatted;
			},
			fields() {
				const metadata = vm.value.header.metadata;
				const path = this.navigation.selectedSlide ? this.navigation.selectedSlide.path : [];
				const slideNumber =
					this.navigation.selectedSlideIndex !== null ? (this.navigation.selectedSlideIndex + 1).toString() : 0;

				return [
					{ id: 'content_title', label: metadata.title },
					{ id: 'content_custom_id', label: metadata.custom_id },
					{
						id: 'slide_title',
						label: this.navigation.selectedSlide ? this.navigation.selectedSlide.title : ''
					},
					{
						id: 'slide_parent_title',
						label: path && path.length > 1 ? path[path.length - 2].title : ''
					},
					{
						id: 'slide_number',
						label: slideNumber
					},
					{ objectives: this.objectives },
					{ breadcrumb: path }
				];
			},
			layouts() {
				return this.lessonPlanContents.layouts
					? this.lessonPlanContents.layouts.filter(layout => layout.imported === false)
					: [];
			},
			importedLayouts() {
				return this.lessonPlanContents.layouts
					? this.lessonPlanContents.layouts.filter(layout => layout.imported !== false)
					: [];
			},
			templates() {
				return this.lessonPlanContents.templates;
			},
			globalVariables() {
				const path = this.navigation.selectedSlide ? this.navigation.selectedSlide.path : [];
				const slideNumber =
					this.navigation.selectedSlideIndex !== null ? (this.navigation.selectedSlideIndex + 1).toString() : 0;
				const selectedSlide = this.navigation.selectedSlide;

				return [
					{
						name: 'ContentMetadataCustomId',
						title: 'Custom Id',
						type: 'string',
						value: vm.value.header.metadata.custom_id
					},
					{
						name: 'ContentMetadataTitle',
						title: 'Title',
						type: 'string',
						value: vm.value.header.metadata.title
					},
					{
						name: 'SlideTitle',
						title: 'Slide Title',
						type: 'string',
						value: selectedSlide ? selectedSlide.title : ''
					},
					{
						name: 'SlideNumber',
						title: 'Slide Number',
						type: 'string',
						value: slideNumber
					},
					{
						name: 'SlideParentTitle',
						title: 'Parent Title',
						type: 'string',
						value: path && path.length > 1 ? path[path.length - 2].title : ''
					},
					{
						name: 'SlidePath',
						title: 'Slide Path',
						type: 'array',
						value: path,
						private: true
					},
					{
						name: 'TotalTimeLearningObject',
						title: 'Total Time Learning Object',
						type: 'string',
						value: this.totalTimeLearningObjectsFormatted
					},
					{
						name: 'ObjectiveCustomId',
						title: 'Slide Objective custom id',
						type: 'string',
						value: this.objectiveCustomIdGlobalVariable
					},
					{
						name: 'ObjectiveTitle',
						title: 'Slide Objective Title',
						type: 'string',
						value: this.objectiveTitleGlobalVariable
					},
					{
						name: 'ObjectiveText',
						title: 'Slide Objective Text',
						type: 'string',
						value: this.objectiveTextGlobalVariable
					}
				];
			},
			isViewReviewOrActivityMode() {
				return this.mode === 'activity' || this.mode === 'view' || this.mode === 'review';
			},
			isPreviewMode() {
				return this.getLastPathCurrentUrl() === 'preview';
			},
			isReviewMode() {
				return this.getLastPathCurrentUrl() === 'draft' && this.mode !== 'edit';
			},
			lessonPlanObject() {
				return vm.value;
			},
			externalAttachments() {
				return vm.value.body && vm.value.body.contents && vm.value.body.contents.externalAttachments
					? vm.value.body.contents.externalAttachments
					: [];
			},
			hasSelectedSlideSpeakerNotes() {
				const speakerNotes = this.navigation.selectedSlide.notes.speaker;

				return speakerNotes !== '<p></p>' && speakerNotes !== '';
			},
			hasSelectedSlideAudienceNotes() {
				const audienceNotes = this.navigation.selectedSlide.notes.audience;

				return audienceNotes !== '<p></p>' && audienceNotes !== '';
			},
			hasSelectedSlideVideoNotes() {
				return this.navigation.selectedSlide.notes.video;
			}
		},
		watch: {
			view: {
				deep: true,
				handler() {
					this.updateSelectedSlideFromComment();
				}
			},
			'navigation.selectedSlide.title'() {
				this.setPathTitle();
			},
			'globalStyles.block.fontFamily': {
				handler() {
					const defaultFont = this.fontFamilies.find(fontF => fontF.text.includes('Default ('));
					defaultFont.text = `Default (${this.globalStyles.block.fontFamily})`;
				}
			},
			'navigation.selectedSlide': {
				handler() {
					this.answerHandler = { active: false, data: {} };

					if (
						this.activityState &&
						this.navigation.selectedSlide &&
						this.navigation.selectedSlide.blocks &&
						this.navigation.selectedSlide.blocks.length > 0
					) {
						this.navigation.selectedSlide.blocks.forEach(block => {
							if (block.type === 'contentMultipleChoiceQuestion') {
								const slideState = this.getSlideActivityState(this.navigation.selectedSlide);
								if (slideState && slideState.response) {
									this.answerHandler = {
										active: true,
										data: {
											response: slideState.response,
											success: slideState.success,
											objCustomId: slideState.objective ? slideState.objective.custom_id : 'NO-OBJ',
											objTitle: slideState.objective ? slideState.objective.title : 'NO OBJECTIVE',
											sections: slideState.objective ? slideState.objective.sections.join(', ') : 'NO SECTIONS'
										}
									};
								}
							}
						});
					}
					this.subtitlesText = false;
				}
			}
		},
		created() {
			if (this.globalStyles.block && this.globalStyles.block.fontFamily) {
				this.fontFamilies[0].text = `Default (${this.globalStyles.block.fontFamily})`;
			}

			this.navigation = createNavigation({
				slides: this.lessonPlanContents.slides || [],
				mode: () => this.mode,
				activityState: () => this.activityState,
				interactivePresentationLocked: () =>
					this.lessonPlanContents.settings.styles.navigation &&
					this.lessonPlanContents.settings.styles.navigation.locked,
				shouldIncludeHiddenSlides: () => this.hideSlidesService && !this.hideSlidesService.areHidden,
				getSlideActivityState: slide => this.getSlideActivityState(slide),
				navigateToRootSlideIfNeeded: slide => this.navigateToRootSlideIfNeeded(slide),
				notify: ({ text, color }) => this.showNotification(text, color)
			});
			this.navigation.initSlidesTree();

			this.navigation.selectedSlide = this.navigation.slideArray[0];
			this.checkTemplates(); // hotfix to recover templates, layouts & galleries properties (if it was deleted for a bug)
			// Copy Learning Object objective to section objective to make it part of current I.P. dependencies
			this.processLearningObjectives();
			this.buildAndCleanLearningObjects(this.mode === 'edit');
			if (this.isViewReviewOrActivityMode) {
				if (!this.activityState) {
					this.initQuizActivities(); // QUIZ: SlideTemplates transformation to Slides (first time it's going to be built)
					this.initActivityState();
				} else {
					this.initQuizActivities(this.activityState); // QUIZ: Slides transformation with activityState (same questions and order as the first time it was built)
				}
			}

			this.$addBrandingFont();
			injectTenantFontFace();

			if (this.mode === 'edit') this.cleanGarbage();
		},
		methods: {
			canShowPlaceholderNoSlide() {
				return this.navigation.slideArray.length === 0 && this.mode === 'edit';
			},
			setHideSlidesService(hideSlidesService) {
				this.hideSlidesService = hideSlidesService;
			},
			getLocator() {
				const { major_revision, minor_revision } = this.lessonPlanObject.header;
				const { library_id, content_id } = this.lessonPlanObject.header.metadata;

				return {
					libraryId: library_id,
					contentId: content_id,
					revision: `${major_revision}.${minor_revision}`
				};
			},
			modifyFontSize(value) {
				this.notesFontSize += value;
			},
			getLastPathCurrentUrl() {
				return window.location.pathname.split('/').pop();
			},
			checkTemplates() {
				if (!this.lessonPlanContents.layouts) {
					this.$set(this.vm.value.body.contents, 'layouts', []);
				}
				if (!this.lessonPlanContents.templates) {
					this.$set(this.vm.value.body.contents, 'templates', []);
				}
				if (!this.lessonPlanContents.galleries) {
					this.$set(this.vm.value.body.contents, 'galleries', []);
				}
			},
			getSlideFromBlock(blockToFind) {
				for (const slide of this.navigation.slideArray) {
					for (const block of slide.blocks) {
						if (block.id === blockToFind.id) {
							return slide;
						}
					}
				}
			},
			getSlideFromSlideId(slideId) {
				for (const slide of this.navigation.slideArray) {
					if (slide.id === slideId) {
						return slide;
					}
				}
			},
			getParentIdFromSlide(slideToFind) {
				for (const slide of this.navigation.slideArray) {
					if (slide.id === slideToFind.id) {
						// slide.path.length - 2 => the last one is the current slide (length - 1), the previous one is the parent (length - 2)
						if (slide.path.length > 1) {
							return slide.path[slide.path.length - 2].id;
						} else {
							return '$root';
						}
					}
				}
			},
			getSectionForObjective(objectiveId) {
				let sectionId = undefined;
				for (const slide of this.navigation.slideArray) {
					if (slide.objectives && slide.objectives.length > 0) {
						if (slide.objectives.find(objective => objective._id === objectiveId)) {
							sectionId = slide.id;
							break;
						}
					}
				}
				return sectionId;
			},
			buildAndCleanLearningObjects(isEditMode) {
				function addParentIdToPathChildren(slides, parent) {
					slides.forEach(slide => {
						let path = cloneDeep(parent.path);
						if (slide.path) {
							slide.path.unshift(path[0]); //insert LearningObject ID as first position path
						} else {
							slide.path = path;
							slide.path.push({ id: slide.id, title: slide.title });
						}
						if (slide.children && slide.children.length > 0) {
							addParentIdToPathChildren(slide.children, slide);
						}
					});
				}

				function sufixSlideIds(slides, sufix) {
					slides.map(slide => {
						slide.id = `${slide.id}-${sufix}`;
						if (slide.children && slide.children.length) sufixSlideIds(slide.children, sufix);
					});
				}

				function findLearningObjectAndInsertIntoIP(slides) {
					slides.forEach(slide => {
						if (slide.type && slide.type === 'LearningObject') {
							if (!isEditMode) {
								// Build LO childrens for View/Activity/Review mode
								sufixSlideIds(slide.reference.body.contents.slides, slide.id);
								slide.children = slide.reference.body.contents.slides;
								// Add parent path (slide ID) to all Learning Object childrens
								addParentIdToPathChildren(slide.children, slide);
							} else {
								// delete children for "edit mode" #9212
								slide.children = false;
							}
							// Clear unnecessary LO information
							slide.completionTime = slide.reference.body.contents.instructionalSettings
								? slide.reference.body.contents.instructionalSettings.completionTime
								: 0;
							delete slide.reference.body;
						}
						if (slide.children && slide.children.length > 0) {
							findLearningObjectAndInsertIntoIP(slide.children);
						}
					});
				}
				findLearningObjectAndInsertIntoIP(this.lessonPlanContents.slides);
			},
			isSection(slide) {
				return slide ? Array.isArray(slide.children) : false;
			},
			isQuiz(slide) {
				return slide && slide.type ? slide.type === 'QuizSlide' : false;
			},
			isSlide(slide) {
				return slide && slide.type ? slide.type === 'Slide' : !Array.isArray(slide.children);
			},
			isLearningObject(slide) {
				return slide && slide.type ? slide.type === 'LearningObject' : false;
			},
			isQuizChildren(tree, slide) {
				let isQuizChildrenFound = false;

				function isQuizChildrenRec(tree, slideToCheck) {
					for (const node of tree) {
						if (node.type === 'QuizSlide') {
							for (const nodeChildren of node.children) {
								if (nodeChildren.id === slideToCheck.id) {
									isQuizChildrenFound = true;
									break;
								}
							}
						} else if (node.children && node.children.length > 0) {
							isQuizChildrenRec(node.children, slideToCheck);
						}
					}
				}

				isQuizChildrenRec(tree, slide);
				return isQuizChildrenFound;
			},
			hasQuizInIP() {
				for (const slide of this.navigation.slideArray) {
					if (slide.type === 'QuizSlide') {
						return true;
					}
				}
				return false;
			},
			setPathTitle() {
				if (this.navigation.selectedSlide) {
					const path = this.navigation.selectedSlide.path;
					if (path && path.length > 0) {
						path[path.length - 1].title = this.navigation.selectedSlide.title;
					}
					this.setPathTitleChildren();
				}
			},
			setPathTitleChildren() {
				if (this.navigation.selectedSlide.children) {
					this.navigation.selectedSlide.children.forEach(child => {
						if (child.path && child.path[child.path.length - 2]) {
							child.path[child.path.length - 2].title = this.navigation.selectedSlide.title;
						}
					});
				}
			},
			showNotification(notificationText, color) {
				this.notificationHandler = {
					active: true,
					text: notificationText,
					color: color ? color : 'error'
				};
			},
			dismissNotification() {
				this.notificationHandler = {
					active: false,
					text: '',
					color: 'error'
				};
			},
			isSectionAvailable(id) {
				const nextSlideState = this.navigation.slideNavigationMap.find(slide => slide.id === id);
				if (nextSlideState) {
					return nextSlideState.available;
				} else {
					return false;
				}
			},
			gotoNextSlideOutAvailable() {
				const selectNextSlideInRootOfSlideId = id => {
					const slideIndex = this.navigation.slidesTree.slides.findIndex(slide => slide.id === id);
					const nextSlide = this.navigation.slidesTree.slides[slideIndex + 1];
					if (nextSlide) {
						this.navigation.selectSlideById(nextSlide.id);
					} else {
						this.navigation.selectSlideByIndex(this.navigation.slidesVisible.length - 1);
					}
				};

				const searchNextSlide = slide => {
					const parentId = this.getParentIdFromSlide(slide);
					if (parentId === '$root') {
						selectNextSlideInRootOfSlideId(slide.id);
					} else {
						const parentSlide = this.navigation.slideArray.find(slide => slide.id === parentId);
						const currentSlideIndex = parentSlide.children.findIndex(
							child => child.id === this.navigation.selectedSlide.id
						);
						const nextSlide = parentSlide.children[currentSlideIndex + 1];
						if (nextSlide) {
							this.navigation.selectSlideById(nextSlide.id);
						} else {
							searchNextSlide(parentSlide);
						}
					}
				};
				searchNextSlide(this.navigation.selectedSlide);
			},
			selectLayoutById(id, imported = false) {
				let layout = this.lessonPlanContents.layouts.find(l => l.id === id);
				if (layout) {
					this.navigation.selectedSlide = layout.slide;
					this.imported = imported;
				}
			},
			findElementByBookmark(tree, bookmark) {
				let result = {
					found: false
				};
				for (let i = 0; i < tree.length; i++) {
					if (!result.found) {
						if (tree[i].bookmark == bookmark) {
							result = {
								found: true,
								element: tree[i]
							};
						} else if (tree[i].children && tree[i].children.length) {
							result = this.findElementByBookmark(tree[i].children, bookmark);
						}
					}
				}
				return result;
			},
			goToFirstSlide() {
				const slides = this.lessonPlanContents.slides;
				if (slides && slides.length > 0) {
					this.navigation.selectSlideById(slides[0].id);
				}
			},
			goToFirstLayout() {
				if (this.layouts.length > 0) {
					this.selectLayoutById(this.layouts[0].id);
				} else if (this.importedLayouts.length > 0) {
					this.selectLayoutById(this.importedLayouts[0].id, true);
				}
			},
			getSlideFromBookmark(bookmark) {
				return this.findElementByBookmark(this.navigation.slidesTree.slides, bookmark);
			},
			goToBookmarkTarget(bookmark) {
				const slideElement = this.getSlideFromBookmark(bookmark);
				if (slideElement.element) {
					this.navigation.selectSlideById(slideElement.element.id);
				}
			},
			$addBrandingFont() {
				const brandingFont = branding.font;
				if (!brandingFont) return;

				this.fontFamilies.unshift({
					text: brandingFont.family,
					value: brandingFont.family
				});
			},
			getSlideObjectFromId(id) {
				let foundSlide = undefined;
				function searchSlide(slides, id) {
					for (const slide of slides) {
						if (slide.id === id) {
							foundSlide = slide;
							break;
						}
						if (slide.children && slide.children.length > 0) {
							searchSlide(slide.children, id);
						}
					}
				}
				searchSlide(this.lessonPlanContents.slides, id);
				return foundSlide;
			},
			processLearningObjectives() {
				this.navigation.slideArray.forEach(slide => {
					if (
						slide.type === 'LearningObject' &&
						slide.reference &&
						slide.reference.body &&
						slide.reference.body.contents.instructionalSettings &&
						slide.reference.body.contents.instructionalSettings.objective
					) {
						slide.objectives = [slide.reference.body.contents.instructionalSettings.objective];
					}
				});
			},
			toggleSlideNumber() {
				this.slideNumberShown = !this.slideNumberShown;
			},
			getParentQuiz(slide) {
				let parentQuiz = false;
				const parentId = this.getParentIdFromSlide(slide);
				if (parentId) {
					const parent = this.getSlideFromSlideId(parentId);
					if (parent && parent.type === 'QuizSlide') {
						parentQuiz = parent;
					}
				}
				return parentQuiz;
			},
			toggleSubtitles() {
				this.subtitlesActive = !this.subtitlesActive;
			},
			setSubtitlesText(text) {
				this.subtitlesText = text;
			},
			selectDefaultLang(lang) {
				this.defaultSubtitles = lang;
			}
		}
	});
}
